import {FC} from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import { socialOptions } from '../../profile/components/fields/utils'

interface ProfileMemberSocialsProps {
  socialMediaProfiles: any[]
}

const socials = [
  {icon: '/media/svg/nobilis/instagram.svg'},
  {icon: '/media/svg/nobilis/fb_01.svg'},
  {icon: '/media/svg/nobilis/x_01.svg'},
]

export const ProfileMemberSocials: FC<ProfileMemberSocialsProps> = ({socialMediaProfiles}) => {
  return (
    <div className='nb-pm-socials'>
      {(socialMediaProfiles ?? []).map((profile, index) => {
        const option = socialOptions.find((opt) => opt.name.toLowerCase() === profile.platformName.toLowerCase());
        if (!option) return null
        return (<a key={`link-${index}`} href={profile.profileUrl} target='_blank'><SVG key={index} src={toAbsoluteUrl(option.icon2)} /></a>);
      })}
    </div>
  )
}
